export const brandUrl = {
  drumeo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=250,metadata=none/https://dpwjbsxqtam5n.cloudfront.net/logos/logo-blue.png',
  singeo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=250,metadata=none/https://d21xeg6s76swyd.cloudfront.net/sales/2021/singeo-logo.png',
  guitareo: 'https://d38h3dn806jqj1.cloudfront.net/logos/guitareo.svg',
  pianote:
    'https://www.musora.com/cdn-cgi/image/quality=95,width=250,metadata=none/https://d2vyvo0tyx8ig5.cloudfront.net/logo/pianote-logo-red.png'
}

export const whiteLogos = {
  drumeo:'https://d38h3dn806jqj1.cloudfront.net/logos/drumeo-white.svg',
  singeo:'https://d38h3dn806jqj1.cloudfront.net/logos/singeo-white.svg',
  guitareo:'https://d38h3dn806jqj1.cloudfront.net/logos/guitareo-white.svg',
  pianote:'https://d38h3dn806jqj1.cloudfront.net/logos/pianote-white.svg',
  musora: 'https://d38h3dn806jqj1.cloudfront.net/logos/musora-white_new.svg'
}

export const bgColor = {
  singeo: 'tw-bg-singeo',
  drumeo: 'tw-bg-drumeo',
  pianote: 'tw-bg-pianote',
  guitareo: 'tw-bg-guitareo',
  unselected: 'tw-bg-[#FFAE00]'
}

export const bgBottomGradients = {
  singeo: 'tw-from-singeo tw-to-singeo-700',
  drumeo: 'tw-from-drumeo tw-to-drumeo-700',
  pianote: 'tw-from-pianote tw-to-pianote-700',
  guitareo: 'tw-from-guitareo tw-to-guitareo-700'
}

export const textColor = {
  drumeo: 'tw-text-drumeo',
  singeo: 'tw-text-singeo',
  guitareo: 'tw-text-guitareo',
  pianote: 'tw-text-pianote'
}

export const borderColor = {
  drumeo: 'tw-border-drumeo',
  singeo: 'tw-border-singeo',
  guitareo: 'tw-border-guitareo',
  pianote: 'tw-border-pianote',
  red: 'tw-border-red-400',
  green: 'tw-border-green-400',
  blue: 'tw-border-blue-400',
  yellow: 'tw-border-yellow-400',
  orange: 'tw-border-[#F06314]',
}

export const bgImg = {
  drumeo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=1920,height=1080,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/drumeo-bg.jpg',
  singeo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=1920,height=1080,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/singeo-bg.jpg',
  guitareo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=1920,height=1080,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/guitareo-bg.jpg',
  pianote: 'https://www.musora.com/cdn-cgi/image/quality=95,width=1920,height=1080,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/pianote-bg.jpg'
}

export const bgImgCard = {
  drumeo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=500,height=500,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/drumeo-card.jpg',
  singeo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=500,height=500,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/singeo-card.jpg',
  guitareo: 'https://www.musora.com/cdn-cgi/image/quality=95,width=500,height=500,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/guitareo-card.jpg',
  pianote: 'https://www.musora.com/cdn-cgi/image/quality=95,width=500,height=500,metadata=none/https://d3fzm1tzeyr5n3.cloudfront.net/onboarding-images/pianote-card.jpg'
}

// do not delete this is needed for tailwind to generate what is needed, just add here any code generated style
const __usedVars = [
  'peer-checked:tw-bg-drumeo',
  'peer-checked:tw-bg-pianote',
  'peer-checked:tw-bg-singeo',
  'peer-checked:tw-bg-guitareo',
  'hover:tw-bg-drumeo-600',
  'hover:tw-bg-pianote-600',
  'hover:tw-bg-guitareo-600',
  'hover:tw-bg-singeo-600',
  'hover:tw-text-drumeo-600',
  'hover:tw-text-pianote-600',
  'hover:tw-text-guitareo-600',
  'hover:tw-text-singeo-600',
  'hover:tw-border-drumeo',
  'hover:tw-border-pianote',
  'hover:tw-border-singeo',
  'hover:tw-border-guitareo',
  'hover:dark:tw-border-drumeo',
  'hover:dark:tw-border-pianote',
  'hover:dark:tw-border-singeo',
  'hover:dark:tw-border-guitareo',
  'hover:tw-border-red-400',
  'hover:tw-border-green-400',
  'hover:tw-border-blue-400',
  'hover:tw-border-yellow-400',
  'hover:tw-border-[#F06314]',
  'md:tw-bg-drumeo',
  'md:tw-bg-singeo',
  'md:tw-bg-guitareo',
  'md:tw-bg-pianote',
  'md:tw-bg-[#FFAE00]',
  'tw-bg-pianote/10',
  'tw-bg-drumeo/10',
  'tw-bg-guitareo/10',
  'tw-bg-singeo/10',
  'tw-bg-[#FFAE00]/10'
]
